<template lang="html">

  <section class="error-404 row-center wrapper">
    <div class="left"></div>
    <div class="right column-center">
      
        <h2>404</h2>
        <h3 class="hand-title">Pagína no encontrada</h3>
        <img width="220" src="/static/img/decorado-carretillero.svg">
        <p>La página que buscas no se encuentra, pero puedes seguir navegando por nuestra web</p>
        <router-link class="classic-btn" tooltip="Volver" to="/">Volver</router-link>

    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'error-404',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .error-404 {
    height: 100vh;
  }

  .error-404 > div{
    width: 50%;
    height: 100vh;
  }

  .error-404 .left{
    background: url(/static/img/background-404.jpg) center/cover no-repeat;
  }

  .error-404 .right{
    padding: 10vw;
  }

  .error-404 h2{
  font-size: 200px;
  color: #b69645;
  line-height: 1em;
  font-family: 'philosopherbold';
  }

  .error-404 img{
    margin:20px 0;
  }

  .error-404 .classic-btn{
    margin-top: 30px;
  }

  @media screen and (max-width: 900px){
    .error-404 .right{
      width: 100%;
      padding: 20px;
    }

    .error-404 .right p{
      max-width: 400px;
    }

    .left{
      display: none;
    }
  }


    @media screen and (max-width: 500px){
      .error-404 h2{
        font-size: 100px;
      }
    }

</style>



// WEBPACK FOOTER //
// src/components/views/error-404.vue